/*module.exports = ['PaybeatsTracks'];
module.exports = ['PaybeatsNFT']; */

module.exports = ['PaybeatsNFT','SafeTokenV1Beta', 'SerumNFT']